import { render, staticRenderFns } from "./ModifyPlan.vue?vue&type=template&id=2faefca3"
import script from "./ModifyPlan.vue?vue&type=script&lang=js"
export * from "./ModifyPlan.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports